import React from "react";
import styles from "./FileUpload.module.css"; // Import the CSS module

const FileUpload = ({
  selectedFile,
  handleFileChange,
  name,
  deleteFile,
  loading = false,
  deleteFileText = 'Delete File'
}) => {
  return (
    <div className={styles.fileUploadContainer}>
      {selectedFile && !loading ? (
        <>
          <label onClick={deleteFile} className={styles.fileUploadButton}>
            {deleteFileText}
          </label>
        </>
      ) : (
        <label
          className={`${styles.fileUploadButton} ${
            loading ? "cursor-not-allowed opacity-50" : ""
          }`}
        >
          <input
            type="file"
            name={name}
            onChange={(event) => handleFileChange(event)}
            disabled={loading}
          />
          Upload File
        </label>
      )}
      <div className={styles.uploadedFile}>
        {selectedFile || "No File Chosen"}
      </div>
    </div>
  );
};

export default FileUpload;
